export const resolveCrmCustomerDeals = (deals, customers) => {
  const byId = new Map(customers.map(customer=>[String(customer.id),customer]));
  return deals.map(deal=>{
    const customer=byId.get(String(deal.customerId || ''));
    return customer ? {...deal,company:customer.name,email:customer.email || ''} : deal;
  });
};
export const crmCustomerChanges = (customer, form) => {
  const patch={};
  if (form.company.trim() !== customer.name) patch.name=form.company.trim();
  const email=form.email.trim().toLowerCase();
  if (email !== (customer.email || '').toLowerCase()) {
    const others=(customer.emails || []).filter(item=>!item.isDefault && item.value!==email);
    patch.emails=email ? [{value:email,label:(customer.emails || []).find(item=>item.isDefault)?.label || '',isDefault:true},...others]
      : others.map((item,index)=>({...item,isDefault:index===0}));
  }
  return patch;
};
